import React from 'react'
import { Nav } from './Layout'
import { connect } from 'react-redux'
import NavPageLinks from './NavPageLinks'
import { selectUserLocationId } from '../../redux/modules/selectors'

export const DefaultNav = ({ pageName, locationId }) => {
  return (
    <Nav>
      <div className="sticky">
        <NavPageLinks locationId={locationId} pageName={pageName} />
      </div>
    </Nav>
  )
}
const mapStateToProps = state => {
  const locationId = selectUserLocationId(state)
  return {
    locationId,
  }
}
const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultNav)
